import { Card, Flex, Spinner, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

import type { ExtractionStatusItem } from "../../hooks/use-bank-statement-extraction-statuses";

type ExtractedStatementsProps = {
  items: ExtractionStatusItem[];
};

const ExtractionStatusTile = ({ upload, status, exceededMaxPollTime }: ExtractionStatusItem) => {
  const intl = useIntl();
  const state = exceededMaxPollTime ? "failed" : status?.extractionState ?? "created";

  return (
    <Card padding="small">
      <Flex direction="column" gap="2">
        <Flex justify="space-between" align="center">
          <Text fontWeight="semiBold">{upload.name}</Text>
          {state === "created" && <Spinner size={16} />}
        </Flex>

        {state === "created" && (
          <Text size="sm" color="subtle">
            {intl.formatMessage(MESSAGES.extractionProcessingText)}
          </Text>
        )}

        {state === "failed" && (
          <Text size="sm" color="critical">
            {intl.formatMessage(MESSAGES.extractionFailedText)}
          </Text>
        )}
      </Flex>
    </Card>
  );
};

export const ExtractedStatements = ({ items }: ExtractedStatementsProps) => {
  const intl = useIntl();

  if (items.length === 0) {
    return null;
  }

  return (
    <Flex direction="column" gap="2" maxWidth="594px">
      <Text fontWeight="semiBold">{intl.formatMessage(MESSAGES.extractedStatementsSectionTitle)}</Text>
      <Flex direction="column" gap="2">
        {items.map((item) => (
          <ExtractionStatusTile key={item.upload.objectKey} {...item} />
        ))}
      </Flex>
    </Flex>
  );
};
